import { atom } from "jotai";

/**
 * True while the cart cross-sell popup is on screen.
 *
 * Adding a recommended product from inside that popup fires the same add-to-cart
 * path as anywhere else, which raises `goToCartAtom` — and a second modal
 * stacking on top of the one the shopper is shopping in is a dead end on a
 * phone. `GoToCartPopUp` reads this and stands down while the popup is open.
 */
export const crossSellPopupOpenAtom = atom(false);

/**
 * Counts the `POST /carts/items` writes that actually succeeded, incremented
 * right after the cart cache has been updated with the response.
 *
 * The add-to-cart buttons raise `goToCartAtom` on the *click*, so it says "the
 * shopper asked for this", not "it worked". Anything that must wait for the item
 * to really be in the cart watches this instead: capture the count up front and
 * wait for it to increase.
 */
export const cartItemSavedCountAtom = atom(0);
